import { toastActions } from "src/design-system/Toast/utils";
import { humanReadableSize } from "src/utils/files";

export const MAX_CSV_IMPORT_SIZE_BYTES = 1024 * 1024; // 1 MB

export const handleCsvImportRejected = (rejectedFiles: { file: File }[]) => {
  const file = rejectedFiles[0]?.file;
  if (file && file.size > MAX_CSV_IMPORT_SIZE_BYTES) {
    toastActions.failure({
      title: "File too large",
      description: `"${file.name}" exceeds the maximum import size of ${humanReadableSize(MAX_CSV_IMPORT_SIZE_BYTES)}.`,
    });
  }
};
